import React from 'react';
import { Transition } from 'react-transition-group';
import { useAdminTranslation } from '@/admin/hooks/useAdminTranslation';
import classes from 'classnames';
import AppModal from '@/components/AppModal/AppModal';
import AppBackdrop from '@/components/AppBackdrop';
import TheButton from '@/components/school-management/TheButton/TheButton';
import AppIcon from '@/components/school-management/AppIcon/AppIcon';
import styles from './ClassCodeModal.module.scss';
import copyIcon from '@/assets/svg/copy.svg';
import SVG from 'react-inlinesvg';

interface ClassCodeModalProps {
  open: boolean;
  classCode: string;
  invitationUrl?: string;
  onClose: () => void;
}

const ClassCodeModal: React.FC<ClassCodeModalProps> = ({
  open,
  classCode,
  invitationUrl,
  onClose,
}) => {
  const { t } = useAdminTranslation();

  const handleCopyInvitation = async () => {
    const textToCopy = invitationUrl || classCode;
    try {
      await navigator.clipboard.writeText(textToCopy);
      // Close modal and redirect after copying
      onClose();
    } catch (err) {
      console.error('Failed to copy invitation:', err);
    }
  };

  return (
    <Transition in={open} timeout={400} mountOnEnter unmountOnExit>
      {state => {
        return (
          <>
            <AppBackdrop
              className={classes(styles.backdrop, `backdrop-${state}`)}
              emitClose={onClose}
            />
            <AppModal show={true} type='fade' showBackdrop={false}>
              <div className={classes(styles.classCodeModal, `fade-${state}`)}>
                <button
                  className={styles.closeBtn}
                  onClick={onClose}
                  aria-label={t('common.close') || 'Close'}
                >
                  <AppIcon icon='close' size={20} />
                </button>

                <h2>{t('classCodeModal.yourClassCode')}</h2>

                <h2>{classCode}</h2>

                <span className={styles.description}>
                  {t('classCodeModal.copyClassCodeDescription')}
                </span>

                {invitationUrl && (
                  <div className={styles.urlContainer}>
                    <span className={styles.urlText}>{invitationUrl}</span>
                  </div>
                )}

                <TheButton
                  className={classes(styles.copyBtn, styles.cancelBtn)}
                  text={t('classCodeModal.copyClassCode')}
                  emitOnClick={handleCopyInvitation}
                  shouldRecolor={false}
                />
              </div>
            </AppModal>
          </>
        );
      }}
    </Transition>
  );
};

export default ClassCodeModal;
